import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const Folder = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='1'
        strokeLinecap='round'
        strokeLinejoin='round'
        className='lucide lucide-folder-icon lucide-folder'
      >
        <path d='M4 21H20C20.6 21 21 20.6 21 20V10C21 9.4 20.6 9 20 9H13V7C13 5.8 12.2 5 11 5H5C3.8 5 3 5.8 3 7V20C3 20.6 3.4 21 4 21Z' />
      </svg>
    </SvgIcon>
  );
};

export default Folder;
